<div class="container-fluid py-4">
  <div class="py-4">
    <div class="d-inline-block align-middle me-3">
      <svg-icon src="assets/icons/icon-about-us.svg" class="icon-about-us"> </svg-icon>
    </div>
    <h1 class="d-inline-block align-middle m-0">{{ 'ABOUT_US_TITLE' | translate }}</h1>
  </div>
  <h2 class="h3 mb-4">
    Application has ability to create secure communities for Doctors, Families, Foundations, Researchers and Medical
    staff to connect, share and communicate information together.
  </h2>
  <p>
    Community — society, area of people with similar interests. Communities are created by the users. They can be by
    disease, location, projects. A project (lung cancer) will live in a community (Cancer Patients). Communities don’t
    carry the same level of security as projects.
  </p>
  <p>The community may have lots of projects.</p>
  <p>To have access to communities, the user should send a request or have an invitation.</p>
  <p>
    Project — activity, business created around some goal or cause. Projects can be for research, creating a foundation,
    gathering data, connecting families or personal like Joe’s cancer diet. Also users can setup projects if they want
    to create an initiative themselves.
  </p>
  <p>
    Allow for projects to merge or link in the application. So individuals and projects can collaborate together or if
    they both started a similar project and want to join forces.
  </p>
  <p>Example: 4 people have similar disease, we create a project to hold a foundation;</p>
  <p>Access should be on the project level.</p>
  <p>Projects types — the categories the project falls into, research, foundation, pharma. etc.</p>
  <p>
    Global Security and Ethics Counsel — Seven Doctors selected from a global pool with diverse backgrounds on patient
    security (security on 1LIFE2CONNECT™ will be above and beyond HIPPA, EU and Asian requirements) and ethics (based
    on or higher than current global medical standards). Seven Patients selected from a global pool of diverse
    backgrounds on patient information and security and ethics.
  </p>
  <p>
    They will setup the rules and enforce them for the site. Additionally they will set the charter, strategy,
    requirements and direction for the site.
  </p>
</div>
